export const Subjects = {
    all: 'all',

    AdminScope: 'AdminScope',
    ClubScope: 'ClubScope',
    RefereeScope: 'RefereeScope',

    Auth: 'Auth',
    Club: 'Club',
    Competition: 'Competition',
    Cup: 'Cup',
    // per user (users.data_volley_admin), added by applyDataVolleyAdminAbility
    DataVolleyAdmin: 'DataVolleyAdmin',
    Export: 'Export',
    Game: 'Game',
    Guest: 'Guest',
    Jersey: 'Jersey',
    MyClub: 'MyClub',
    MyCup: 'MyCup',
    MyTeam: 'MyTeam',
    PlayerTeam: 'PlayerTeam',
    Registration: 'Registration',
    RegistrationComity: 'RegistrationComity',
    Team: 'Team',
    Tournament: 'Tournament',
    User: 'User',
}
